
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-started",
      function () {
        return require("private-next-pages/get-started.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-started"])
      });
    }
  